<ng-container *transloco="let t; read: 'user'">
  @if (studentInfo) {
    <div class="input-rating-sheet">
      @for (domain of studentDomains; track domain) {
        <div>
          <drdp-container additionClasses="min-h-[15rem] mt-4">
            <div class="md:flex place-content-between place-items-center self-center">
              <div class="font-semibold text-xl">
                <img [ngClass]="{
                  'domain-icon': !studentInfo?.is2025Enrollment,
                  'domain-icon-2025-core': studentInfo?.is2025Enrollment && isCoreDomain(domain.domainCode),
                  'domain-icon-2025-supplemental': studentInfo?.is2025Enrollment && !isCoreDomain(domain.domainCode)
                }" src="assets/images/domains/{{domain.iconName}}" [alt]="domain.domainCode">
                <!-- Domain code and name are server-supplied: localized by the API, not by Transloco. -->
                {{domain.domainCode}} - {{domain.domainName}}
              </div>
            </div>
            <div class="mt-4 overflow-x-auto">
              <table class="table-auto min-w-full" [attr.aria-label]="t('inputRating.scantron.tableLabel')">
                <thead>
                  <tr>
                    <th class="border border-gray-200 font-medium text-xs px-4 py-3">
                      {{ t('inputRating.scantron.measureHeader') }}
                    </th>
                    <!-- Measure condition names, level names and descriptions below are server-supplied. -->
                    @if (domain.notYet) {
                      <th class="border border-gray-200 font-medium text-xs px-4 py-3">
                        {{domain.notYet.measureConditionName}}
                      </th>
                    }
                    @for (level of domain.domainLevels; track level) {
                      <th class="border border-gray-200 font-medium text-xs px-4 py-3"
                        >
                        {{level.levelName}}
                      </th>
                    }
                    @if (domain.conditional) {
                      <th class="border border-gray-200 font-medium text-xs px-4 py-3">
                        {{domain.conditional.description}}
                      </th>
                    }
                    @if (domain.EM) {
                      <th class="border border-gray-200 font-medium text-xs px-4 py-3">
                      {{domain.EM.measureConditionCode}}</th>
                    }
                    @if (domain.UR) {
                      <th class="border border-gray-200 text-xs px-4 py-3"
                        [ngClass]="{'text-left': isKinder}">
                        <span class="font-medium "> {{domain.UR.measureConditionCode}} </span>
                        @if (isKinder) {
                          <p class="font-light">{{ t('inputRating.scantron.unableToRateHint') }}</p>
                        }
                      </th>
                    }
                  </tr>
                </thead>
                <tbody class="bg-white">
                  @for (measure of domain.measures; track measure) {
                    <tr>
                      <td class="p-3 border-t border-b border-r border-l border-gray-200">
                        <!-- Measure code and name are server-supplied. -->
                        <p class="font-bold text-xs">{{measure.code}}</p>
                        <p class="text-xs w-36">{{measure.name}}</p>
                      </td>
                      <!-- Not Yet -->
                      @if (domain.notYet) {
                        <td class="p-3 border-t border-b border-r border-l border-gray-300"
                          [ngClass]="{'bg-gray-300': !measure.notYet}">
                          @if (measure.notYet) {
                            <div class="flex justify-center">
                              <mat-checkbox class="font-medium" [id]="measure.code + 'NY'" [name]="measure.code + 'NY'"
                                [checked]="measure.isNotYet" [(ngModel)]="measure.isNotYet" [ngModelOptions]="{standalone: true}"
                                (change)="toggleMeasureNotYet(domain, measure, measure.notYet)"
                                [disabled]="studentInfo.isLocked || measure.isUR || isRatingDisabled">
                                <label class="sr-only" [for]="measure.code + 'NY'">{{measure.notYet.measureConditionName}}</label>
                              </mat-checkbox>
                            </div>
                          }
                        </td>
                      }
                      <!-- Levels -->
                      @for (level of measure.displayLevels; track level) {
                        <td class="p-3 border-t border-b border-r border-l border-gray-300"
                          [ngClass]="{'bg-gray-300': level.isDisabled}">
                          @if (!level.isDisabled) {
                            <div class="flex justify-center"
                              (click)="selectLevel(domain, measure, level)">
                              <label class="sr-only" [for]="measure.code + level.value">{{level.name}} </label>
                              <input type="radio" [id]="measure.code + level.value" [name]="measure.code + level.value"
                                [value]="level.value" [(ngModel)]="measure.ratingValue"
                                [disabled]="studentInfo.isLocked || measure.isUR || measure.isNotYet || isRatingDisabled" />
                            </div>
                          }
                        </td>
                      }
                      <!-- Conditional -->
                      @if (domain.conditional) {
                        <td class="p-3 border-t border-b border-r border-l border-gray-300"
                          [ngClass]="{'bg-gray-300': !measure.conditional}">
                          @if (measure.conditional) {
                            <div class="flex justify-center"
                              (click)="selectCondition(domain, measure, measure.conditional)">
                              <label class="sr-only" [for]="measure.code + 'C'">{{measure.conditional.measureConditionName}}
                              </label>
                              <input type="radio" [id]="measure.code + 'C'" [name]="measure.code + 'C'"
                                [value]="measureCondition.Conditional" [(ngModel)]="measure.measureConditionId"
                                [ngModelOptions]="{standalone: true}"
                                [disabled]="studentInfo.isLocked || measure.isUR || measure.isNotYet || isRatingDisabled" />
                            </div>
                          }
                        </td>
                      }
                      <!-- EM -->
                      @if (domain.EM) {
                        <td class="p-3 border-t border-b border-r border-l border-gray-300"
                          [ngClass]="{'bg-gray-300': !measure.EM}">
                          @if (measure.EM) {
                            <div class="flex justify-center">
                              <mat-checkbox class="font-medium" [id]="measure.code + 'EM'" [name]="measure.code + 'EM'"
                                [checked]="measure.isEM" [(ngModel)]="measure.isEM" [ngModelOptions]="{standalone: true}"
                                (change)="toggleMeasureEM(domain, measure)"
                                [disabled]="!measure.canEmerging || studentInfo.isLocked || measure.isNotYet || isRatingDisabled">
                                <label class="sr-only" [for]="measure.code + 'EM'">{{measure.EM.measureConditionName}} </label>
                              </mat-checkbox>
                            </div>
                          }
                        </td>
                      }
                      <!-- UR -->
                      @if (domain.UR) {
                        <td class="p-3 border-t border-b border-r border-l border-gray-300"
                          [ngClass]="{'bg-gray-300': !measure.UR}">
                          @if (measure.UR) {
                            <div class="flex" [ngClass]="{'justify-center': !isKinder}">
                              <mat-checkbox class="font-medium" [id]="measure.code + 'UR'" [name]="measure.code + 'UR'"
                                [checked]="measure.isUR" [(ngModel)]="measure.isUR" [ngModelOptions]="{standalone: true}"
                                (change)="toggleMeasureUR(domain, measure, measure.UR)"
                                [disabled]="studentInfo.isLocked || measure.isNotYet || isRatingDisabled">
                                <label class="sr-only" [for]="measure.code + 'UR'">{{measure.UR.measureConditionName}} </label>
                              </mat-checkbox>
                              @if (measure.measureConditionId == measureCondition.Unratable && isKinder) {
                                <div class="ml-4 w-36">
                                  <label class="font-normal text-sm m-0" for="reason">{{ t('inputRating.scantron.reasonLabel') }}</label>
                                  <mat-select [placeholder]="t('inputRating.scantron.reasonLabel')" [(ngModel)]="measure.childAssessmentRatingReasonId" id="reason"
                                    [disabled]="studentInfo.isLocked || isRatingDisabled">
                                    @for (reason of carReasons; track reason) {
                                      <mat-option [value]="reason.id"
                                        (click)="selectReason(domain, measure, reason)">
                                        <!-- Reason text is server-supplied. -->
                                        {{ reason.reasonComment }}
                                      </mat-option>
                                    }
                                  </mat-select>
                                </div>
                                @if (measure.showComment) {
                                  <div>
                                    <div class="ml-4 w-36">
                                      <label class="font-normal text-sm m-0" for="comment">{{ t('inputRating.scantron.commentLabel') }}</label>
                                      <mat-form-field appearance="fill">
                                        <input matInput [(ngModel)]="measure.comment" [placeholder]="t('inputRating.scantron.commentPlaceholder')"
                                          maxlength="100" id="comment" autocomplete="off" type="text"
                                          [disabled]="studentInfo.isLocked || isRatingDisabled"
                                          (blur)="emitMeasureChange(domain, measure)" />
                                      </mat-form-field>
                                    </div>
                                  </div>
                                }
                              }
                            </div>
                          }
                        </td>
                      }
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </drdp-container>
        </div>
      }
    </div>
  }
</ng-container>
